import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { CitietouristicService } from 'src/app/api/tourism/citietouristic.service';
declare var $: any;

@Component({
  selector: 'app-citietouristic-form',
  templateUrl: './citietouristic-form.component.html',
  styleUrls: ['./citietouristic-form.component.css']
})
export class CitietouristicFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private citieTouristicService: CitietouristicService,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
      this.citieTouristicService.get(this.checkId).subscribe({
        next: (data: any) => {
          this.item.setValue({
            description: data.data.description
          });
        }
      });
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  saveAdd(){
    this.save_add = true;
    this.onSubmit();
  }

  onSubmit() {
    this.submitted = true;
    this.item.patchValue({
      description: this.item.value.description.toUpperCase()
    });

    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.citieTouristicService
          .update(this.checkId, this.item.value)
          .subscribe({
            next: (data: any) => {
              this.alertifyMsg.success('Registro actualizado con éxito');
              this.router.navigate([
                this.branchofficeSlug + '/turismo/ciudades/lista'
              ]);
            }
          });
      } else {
        this.citieTouristicService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            if(this.save_add){
              this.router.navigate([
                this.branchofficeSlug + '/turismo/ciudades/nuevo'
              ]);
              this.resetForm();
            }else{
              this.router.navigate([
                this.branchofficeSlug + '/turismo/ciudades/lista'
              ]);
            }
            // this.router.navigate([
            //   this.branchofficeSlug + '/turismo/ciudades/lista'
            // ]);

          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    (<any>$("#item_description")).focus();
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/ciudades/lista']);
  }
}
